import Vue from 'vue';
import App from '@/App.vue';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import '@/assets/scss/veka-theme.scss';
import '@/filters/globalFilters';
import { i18n } from '@/i18n';
import DefaultValuesMixin from '@/mixins/DefaultValuesMixin';
import './axios.config';

Vue.config.productionTip = false;
Vue.mixin(DefaultValuesMixin);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
